// extracted by mini-css-extract-plugin
module.exports = {"svg":"style_svg__5WV_L","needsAttentionPulse":"style_needsAttentionPulse__KVzLu"};